import type { FC } from "react"
import React from "react"
import { FormControl, FormLabel, HStack, Input, Text } from "@chakra-ui/react"
import type { FastFieldProps } from "formik"
import { FastField, useFormikContext } from "formik"

import CreateProposalFormError from "createProposal/components/CreateProposalFormError"

type CreateProposalCustomInputProps = {
  label: string
  name: string
  placeholder: string
  validate?: (value?: string) => string | undefined
}

const CreateProposalCustomInput: FC<CreateProposalCustomInputProps> = ({
  label,
  name,
  placeholder,
  validate,
}) => {
  const { setFieldValue, validateForm } = useFormikContext()

  return (
    <FastField name={name} validate={validate}>
      {({ field, meta }: FastFieldProps) => {
        const { name, onBlur, onChange } = field
        const isInvalid = Boolean(meta.error && meta.touched)

        const handleBlur = async (e: React.FocusEvent<HTMLInputElement>) => {
          if (placeholder !== "string") {
            const trimmedValue = e.target.value.trim()

            await setFieldValue(name, trimmedValue, true)

            onBlur(e)

            validateForm()
          }
        }

        return (
          <FormControl isInvalid={isInvalid}>
            <HStack h={10}>
              <FormLabel
                alignItems="center"
                bg="purple.50"
                border="gray.dark"
                color="purple.600"
                display="flex"
                h="full"
                justifyContent="center"
                m={0}
                p={1}
                w={220}
              >
                <Text textStyle="body.bold.lg" w="auto">
                  {label}
                </Text>
              </FormLabel>
              <Input
                name={name}
                placeholder={placeholder}
                value={field.value}
                onBlur={handleBlur}
                onChange={onChange}
              />
            </HStack>
            <CreateProposalFormError error={meta.error} />
          </FormControl>
        )
      }}
    </FastField>
  )
}

export default CreateProposalCustomInput
